import {Widget} from "base/assets/js/widget/Widget.js";
import {CommsExpandBtn} from "base/assets/js/widget/CommsExpandBtn.js";
import {Comms} from "base/assets/js/widget/Comms.js";
import {CommControl} from "base/assets/js/widget/CommControl.js";

export class Comm extends Widget {

	_sMp;
	_iId;
	_iLev;
	_bChildrenShow = true;
	_bHide = false;
	_sFromChildMp = false;

	/**
	 * @type {Comms}
	 */
	_oComms;

	run() {

		this._my( { mp: '_sMp', lev: 'i:_iLev', id: 'i:_iId' } );

		// клик, выводит дополнительную панельку управления комментарием
		this._on( 'ShowControl?', 'click', () => {
			const oCommControl = this._rel().typeOf( CommControl ).find();
			// если уже к этому комменту приделана панелька, сбрасываем
			if( oCommControl.getComm() === this ) {
				oCommControl.reset();
				return;
			}
			oCommControl.setComm( this );
			this.bl().insertAdjacentElement( 'beforeend', oCommControl.bl() );
		} );

		this._on( 'ChildrenBtn?', 'click', ( oEvent ) => {

			// убираем помеченные комментарии
			this._oComms.resetActive();

			this._bChildrenShow = !this._bChildrenShow;

			// скроем потомков
			this._rel()
				.typeOf( Comm )
				.cssSel( '[data-mp^="' + this._sMp + '."]' )
				.canEmpty( true )
				.find( true )
				.forEach( ( oComm ) => {
					oComm.toggle( this._bChildrenShow );
					oComm.active( true );
				} );

			// скроем кнопки "показать"
			this._rel()
				.typeOf( CommsExpandBtn )
				.cssSel( '[data-mp-from^="' + this._sMp + '."][data-mp-to^="' + this._sMp + '."]' )
				.canEmpty( true )
				.find( true )
				.forEach( ( oComm ) => {
					oComm.toggle( this._bChildrenShow );
				} );

			this._mod( '', 'comm_children-hide', !this._bChildrenShow );
		} );
	}

	/**
	 * сохранить ссылку на виджет комментариев
	 * @param oComms
	 */
	setComms( oComms ) {
		this._oComms = oComms;
		oComms.setMaxLev( this._attr( '', 'i:lev' ) );
	}

	toggle( bValue ) {
		this._bHide = !bValue;
		this._mod( '', 'comm_hide', this._bHide );
	}

	setVoteDeny() {
		this._mod( '', 'comm_vote-deny', true );
	}

	isHide() {
		return this._bHide;
	}

	active( bValue ) {
		this._mod( '', 'comm_active', bValue );
	}

	setFromChildMp( sFromChildMp ) {
		this._sFromChildMp = sFromChildMp;
		this._mod( '', 'comm_has-from-mp', !!sFromChildMp );
	}

	getFromChildMp() {
		return this._sFromChildMp;
	}

	static mp2a( sMp ) {
		const aRet = [];
		sMp.split( '.' ).forEach( ( sItem ) => {
			aRet.push( parseInt( sItem ) );
		} );
		return aRet;
	}

	_getIndex() {
		return this.bl().getAttribute( 'data-mp' );
	}
	getId() {
		return this._iId;
	}
	getLev() {
		return this._iLev;
	}
	getMp() {
		return this._sMp;
	}
	getRate() {
		return parseInt( this._el( 'Rate' ).textContent );
	}
	setRate( iRate ) {
		const eRate = this._el( 'Rate?' );
		if( eRate ) {
			eRate.textContent = iRate;
		}
	}

	scrollToParent( iLev = null, bToggle = false ) {
		const sMpFrom = this.getMp();
		const aMpFrom = Comm.mp2a( sMpFrom );

		if( aMpFrom.length <= 1 ) {
			// и так верхний уровень
			return;
		}

		if( iLev === null ) {
			iLev = aMpFrom.length - 1;
		}
		const aMpTo = aMpFrom.slice( 0, iLev );
		let sMpTo = aMpTo.join( "." );

		// если уже отрисован комментарий, в нем может быть информация откуда на него перешли
		let sFromChildMp = sMpFrom;

		// если надо чтобы повторный клик возвращал назад
		if( bToggle ) {
			let oCommTo = this._rel().index(sMpTo).canEmpty().typeOf(Comm).find();
			if (oCommTo) {
				const sExistFromChildMp = oCommTo.getFromChildMp();
				if( sExistFromChildMp ) {
					oCommTo.setFromChildMp( false );
					sMpTo = sExistFromChildMp;
					sFromChildMp = '';
				}
			}
		}

		this._oComms.showComment( sMpTo ).then( () => {
			if( !sFromChildMp ) {
				return;
			}
			// установим откуда перешли, если надо
			let oCommTo = this._rel().index( sMpTo ).canEmpty().typeOf( Comm ).find();
			if( oCommTo ) {
				oCommTo.setFromChildMp( sFromChildMp );
			}
		} );
	}
}
